import React, { createContext, useContext, useState, useEffect } from 'react';
import { useAuth } from './AuthContext';
import useSubscriptionStatus from '../hooks/useSubscriptionStatus';

const SubscriptionContext = createContext();

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  return context;
};

export const SubscriptionProvider = ({ children }) => {
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const { user } = useAuth();
  const { hasActiveSubscription, isChecking, checkSubscriptionStatus } = useSubscriptionStatus();

  // Reset modal for non-vendors
  useEffect(() => {
    if (user?.user_type !== 'vendor') {
      setShowSubscriptionModal(false);
    }
  }, [user?.user_type]);

  // Hide modal when user has active subscription
  useEffect(() => {
    if (hasActiveSubscription === true) {
      setShowSubscriptionModal(false);
    }
  }, [hasActiveSubscription]);

  // Show modal logic for unsubscribed vendors
  useEffect(() => {
    if (hasActiveSubscription === false && user?.user_type === 'vendor') {
      // Show modal if vendor doesn't have subscription and is on vendor pages (but not subscription page)
      if (window.location.pathname.startsWith('/vendor') && !window.location.pathname.includes('/subscription')) {
        setShowSubscriptionModal(true);
      }
    }
  }, [hasActiveSubscription, user?.user_type]);

  const hideSubscriptionModal = () => {
    setShowSubscriptionModal(false);
  };

  const openSubscriptionModal = () => {
    setShowSubscriptionModal(true);
  };

  const value = {
    hasActiveSubscription,
    showSubscriptionModal: openSubscriptionModal,
    hideSubscriptionModal,
    checkSubscriptionStatus,
    isChecking,
    showSubscriptionModalState: showSubscriptionModal
  };

  return (
    <SubscriptionContext.Provider value={value}>
      {children}
    </SubscriptionContext.Provider>
  );
};
